module.exports = __webpack_public_path__ + "media/site_templates/www.tapreplacement.com.au/images/our_services_1-d0bc15d99273ab9fdb76b2cff4f37b61.jpg";